import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import axios from "axios";
import { ReactQueryKey } from "../../types";

export interface IGetBookingDomainsReturn {
    statuses: {
        code: string,
        label: string
    }[],
    substatuses: {
        code: string,
        label: string,
        status: string
    }[]
}

export const getBookingDomains = async (): Promise<IGetBookingDomainsReturn> => {
    const response = await axios.get('/booking/search/domains');
    return response.data;
};

export const useBookingDomainsQuery = (options?: UseQueryOptions<IGetBookingDomainsReturn>) => {
    return useQuery<IGetBookingDomainsReturn>(
        [ReactQueryKey.BookingDomains],
        getBookingDomains,
        options
    );
};